
import React from 'react';
import { Button} from 'react-bootstrap';
import { WHITE } from '../helpers/constants/colors';
import { toCurrency } from '../helpers/functions/math';

const TableEntry = ({ deleteRow, elem, id }) =>
(
    <tr key={id}>
        <td><h6>{elem.name}</h6></td>
        <td><h6>{toCurrency(elem.value)}</h6></td>
        <td><Button variant={WHITE} onClick={() => deleteRow(id)}>X</Button></td>

    </tr>
)


export default TableEntry;
